import { Alert, Space } from 'antd'
import { FieldWarning, WarningField } from '../inputSanityModel'
import CoachingDisclosure from './CoachingDisclosure'
import RevenueQuickFix from './RevenueQuickFix'
import './CrossInputCard.css'

type Props = {
  warning: FieldWarning | null
  salesGoal: number | null
  onSalesGoalChange: (salesGoal: number | null) => void
}

const REVENUE_FIX_FIELDS: WarningField[] = ['revenueScale', 'goalVsPayroll', 'goalVsCosts']

const CrossInputCard = ({ warning, salesGoal, onSalesGoalChange }: Props) => {
  if (warning === null) {
    return null
  }

  const coaching = warning.coaching
  const offersRevenueFix = REVENUE_FIX_FIELDS.includes(warning.field)

  if (!offersRevenueFix && coaching === undefined) {
    return (
      <Alert className="cross-input-card" type="warning" showIcon message={warning.text} />
    )
  }

  return (
    <Alert
      className="cross-input-card"
      type="warning"
      showIcon
      message={warning.text}
      description={
        <Space direction="vertical" size="small" style={{ width: '100%' }}>
          {offersRevenueFix && (
            <RevenueQuickFix salesGoal={salesGoal} onSave={onSalesGoalChange} />
          )}
          {coaching !== undefined && <CoachingDisclosure coaching={coaching} />}
        </Space>
      }
    />
  )
}

export default CrossInputCard
